<template>
  <div>
    <a-row>
      <a-tabs default-active-key="1">
        <a-tab-pane tab="TIPO DE PRENDA" key="1">
          <g-master :name="master.endpoint"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                    <a-input
                      v-decorator="['description', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                    />
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Tipo De Dotación')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_endowment_type', { rules: [{ required: false }] }]"
                              :params="tipo_dotacion">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Estado')" :has-feedback="false">
                    <a-checkbox
                      v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="TALLAS" key="1">
              <garment_size_dot v-if="idSeleccionado" :id_garment_type="idSeleccionado"></garment_size_dot>
              <span v-else>Seleccione una prenda para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipo_dotacion: {
          h_lookup_type: 'TIPO_DOTACION'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'garment_type_dot',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Descripcion', dataIndex: 'description', sorter: true},
              {title: 'Tipo', dataIndex: 'id_h_endowment_type_desc', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'description'},
            {name: 'id_h_endowment_type'},
            {name: 'status'}
          ]
        }
      }
    },
    computed: {
      idSeleccionado () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Dotaciones/GarmentTypeDot.vue